<template>
  <div>
    <vue-apex-charts
      ref="barChart"
      type="bar"
      height="350"
      :options="barChart.chartOptions"
      :series="barChart.series"
      @dataPointSelection="handleClick"
    ></vue-apex-charts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
  },
  data: () => ({
    themeColors: [],
    barChart: {
      series: [],
      chartOptions: {
        colors: ['#28C76F75', '#28C76F'],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (value, timestamp, opts) {
              return getMonth(value)
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (value, timestamp, opts) {
              return `$ ${formatNumber(value)}`
            },
          },
        },
      },
    },
  }),
  methods: {
    handleClick(event, chartContext, config) {
      this.$emit('clickChart', config)
    },
    updateChartData() {
      this.$refs.barChart.updateOptions({
        xaxis: { categories: this.chartData.categories },
        colors: this.chartData.colors,
      })
      this.$refs.barChart.updateSeries(this.chartData.series)
    },
  },
  mounted() {
    this.updateChartData()
    this.$refs.barChart.updateOptions({ title: { text: this.title } })
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({ series: [], categories: [], colors:['#BC130075','#BC1300'] }),
    },
  },
  watch: {
    chartData(val) {
      this.updateChartData()
    },
  },
}

function getMonth(month) {
  let months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'Octuber',
    'November',
    'December',
  ]
  return months[month - 1]
}

function formatNumber(n, decimals = 0) {
  n = Number(n)
  return n.toLocaleString('en-US', {
    style: 'decimal',
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  })
}
</script>